/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Preset_Manager_Export_All_Success_ToastInputs */



/**
* | output |
* | --- |
* | "{count} preset(s) exported successfully" |
*
* @param {Preset_Manager_Export_All_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_export_all_success_toast = /** @type {((inputs: Preset_Manager_Export_All_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Export_All_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} preset(s) exporte(s) avec succes`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count}-Voreinstellung(en) erfolgreich exportiert`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} preset esportati correttamente`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Предустановки ${i?.count} успешно экспортированы.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} ajustes preestablecidos exportados exitosamente`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} 预设已成功导出`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} プリセットが正常にエクスポートされました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} प्रीसेट सफलतापूर्वक निर्यात किए गए`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Predefinições ${i?.count} exportadas com sucesso`)
	return /** @type {LocalizedString} */ (`${i?.count} preset(s) exported successfully`)
});